import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomerTabsPage } from './customer-tabs';

@NgModule({
  declarations: [
    CustomerTabsPage,
  ],
  imports: [
    IonicPageModule.forChild(CustomerTabsPage),
  ],
})
export class CustomerTabsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/customer-tabs/customer-tabs.module.ts